angular.module('gm.common.directives', [
  'angularLoad',
  'ngMessages',
]);
